<template>
  <name-input
    v-if="node.meta.type === 'title' || isTitle"
    :node="node"
    :editMode="editMode"
    :editIndex="editIndex"
    :createMode="createMode"
    :singleEditModeid="singleEditModeid"
    :selectedRecord="selectedRecord"
    :isRoot="isRoot"
  ></name-input>
  <text-input
    v-else-if="node.meta.type === 'text'"
    :node="node"
    :editMode="editMode"
    :editIndex="editIndex"
    :createMode="createMode"
    :singleEditModeid="singleEditModeid"
    :selectedRecord="selectedRecord"
    :isRoot="isRoot"
  ></text-input>
  <numeric
    v-else-if="node.meta.type === 'numeric'"
    :node="node"
    :editMode="editMode"
    :editIndex="editIndex"
    :createMode="createMode"
    :singleEditModeid="singleEditModeid"
    :selectedRecord="selectedRecord"
    :isRoot="isRoot"
  ></numeric>
  <numeric-array
    v-else-if="
      node.meta.type === 'numeric-array' || node.meta.type === 'numeric array'
    "
    :node="node"
    :editMode="editMode"
    :editIndex="editIndex"
    :createMode="createMode"
    :singleEditModeid="singleEditModeid"
    :selectedRecord="selectedRecord"
    :isRoot="isRoot"
  ></numeric-array>
  <text-array
    v-else-if="
      node.meta.type === 'text-array' || node.meta.type === 'text array'
    "
    :node="node"
    :editMode="editMode"
    :editIndex="editIndex"
    :createMode="createMode"
    :singleEditModeid="singleEditModeid"
    :selectedRecord="selectedRecord"
    :isRoot="isRoot"
  ></text-array>
  <numeric-scale
    v-else-if="
      node.meta.type === 'numeric-scale' || node.meta.type === 'numeric scale'
    "
    :node="node"
    :editMode="editMode"
    :editIndex="editIndex"
    :createMode="createMode"
    :singleEditModeid="singleEditModeid"
    :selectedRecord="selectedRecord"
    :isRoot="isRoot"
    v-on:updateconditionalnodes="resetForm()"
  ></numeric-scale>
  <boolean
    v-else-if="node.meta.type === 'boolean'"
    :node="node"
    :editMode="editMode"
    :editIndex="editIndex"
    :createMode="createMode"
    :singleEditModeid="singleEditModeid"
    :selectedRecord="selectedRecord"
    :isRoot="isRoot"
    v-on:updateconditionalnodes="resetForm()"
  ></boolean>
  <SingleValueList
    v-else-if="
      node.meta.type === 'value-list' || node.meta.type === 'value list'
    "
    :node="node"
    :editMode="editMode"
    :editIndex="editIndex"
    :createMode="createMode"
    :singleEditModeid="singleEditModeid"
    :selectedRecord="selectedRecord"
    v-on:updateconditionalnodes="resetForm()"
    :isRoot="isRoot"
  ></SingleValueList>
  <MultipleValueList
    v-else-if="
      node.meta.type === 'multiple-value-list' ||
        node.meta.type === 'multiple value list'
    "
    :node="node"
    :editMode="editMode"
    :editIndex="editIndex"
    :createMode="createMode"
    :singleEditModeid="singleEditModeid"
    :selectedRecord="selectedRecord"
    :isRoot="isRoot"
    v-on:updateconditionalnodes="resetForm()"
  ></MultipleValueList>
  <date
    v-else-if="node.meta.type === 'np-date'"
    :node="node"
    :editMode="editMode"
    :createMode="createMode"
    :singleEditModeid="singleEditModeid"
    :selectedRecord="selectedRecord"
    :isRoot="isRoot"
  ></date>
  <NonPeriodicTextInput
    v-else-if="node.meta.type === 'np-text'"
    :node="node"
    :editMode="editMode"
    :createMode="createMode"
    :selectedRecord="selectedRecord"
    :isRoot="isRoot"
  ></NonPeriodicTextInput>
  <phonenumber
    v-else-if="node.meta.type === 'np-phonenumber'"
    :node="node"
    :editMode="editMode"
    :createMode="createMode"
    :selectedRecord="selectedRecord"
    :isRoot="isRoot"
  ></phonenumber>
</template>

<script>
import { mapActions } from "vuex";
import TextInput from "./form-types/TextInput";
import NameInput from "./form-types/NameInput";
import Numeric from "./form-types/Numeric";
import NumericArray from "./form-types/NumericArray";
import TextArray from "./form-types/TextArray";
import NumericScale from "./form-types/NumericScale";
import Boolean from "./form-types/Boolean";
import SingleValueList from "./form-types/SingleValueList";
import MultipleValueList from "./form-types/MultipleValueList";
import Date from "./form-types/Date.vue";
import NonPeriodicTextInput from "./non-periodic-form-types/np-TextInput.vue";
import phonenumber from "./non-periodic-form-types/np-phonenumber.vue";

export default {
  name: "TypeFactory",
  props: {
    node: Object,
    editMode: Boolean,
    editIndex: Number,
    selectedRecord: Object,
    singleEditModeid: String,
    isRoot: Boolean,
    createMode: Boolean
  },
  components: {
    TextInput,
    NameInput,
    Numeric,
    NumericArray,
    NumericScale,
    Boolean,
    SingleValueList,
    MultipleValueList,
    TextArray,
    Date,
    NonPeriodicTextInput,
    phonenumber
  },

  computed: {
    isTitle() {
      return (
        this.node.meta.type === "text" && typeof this.node.value === "undefined"
      );
    }
  },
  data() {
    return {};
  },

  methods: {
    resetForm() {
      this.$emit("resetform");
    }
  }
};
</script>

<style>
.layout {
  margin: 0;
}
</style>
